export const light = {
    mode: 'light',
    primary: '#3448c5',
    contrastHigh: '#0a0c0f',
    contrastLow: '#333b4c',
    contrastInvert: '#ffffff',
    surface: '#ffffff',
    surfaceAlt: '#f9fafb',
    background: '#f3f4f7',
    backgroundAlt: '#edeef3',
    secondary: '#d1d6e0',
    secondaryAlt: '#c2c9d6',
    error: '#CE190D',
    errorAlt: '#bf160a',
    warning: '#ff620c',
    warningAlt: '#E06F00',
    success: '#22AA00',
    successAlt: '#1f8719',
    overlayLight: 'rgb(249, 250, 251)',
    overlayLight2: 'rgba(249, 250, 251, 0.8)',
    overlayLight3: 'rgba(249, 250, 251, 0.5)',
    overlayDark: 'rgb(10, 12, 15)',
    overlayDark2: 'rgba(10, 12, 15, 0.8)',
    overlayDark3: 'rgba(10, 12, 15, 0.5)',
    code: {
        accent1: '#b4278b',
        accent2: '#22aa01',
        accent3: '#005ce5',
        accent4: '#323a44',
        accent5: '#7c4dff',
        accent6: '#ff5a01',
        accent7: '#01a272',
        accent8: '#38537e',
        accent9: '#ce190e',
    },
    brand: {
        cloudinaryBlue: '#3448c5',
        cloudinaryBlueLight: '#1d3c90',
        cloudinaryBlueDark: '#4c64d7',
        offsetGray: '#f1f2f9',
        darkBlue: '#0c163b',
        accentCoral: '#ff5050',
        accentPeach: '#ffd4c4',
        accentYellow: '#f7bc00',
        accentTurquoise: '#48c4d8',
        accentLightBlue: '#b6d2ff',
    },
    dataVis: {
        accent1: '#3448c5',
        accent2: '#48d0d8',
        accent3: '#ff5050',
        accent4: '#924dff',
        accent5: '#fc41cb',
        accent6: '#ce190f',
        accent7: '#ffb14e',
        accent8: '#22aa03',
        accent9: '#90a0b2',
        accent10: '#323a42',
        accent11: '#ff6000',
        accent12: '#ec0394',
    },
};
export const dark = {
    ...light,
    mode: 'dark',
    primary: '#0D9AFF',
    contrastHigh: '#f9fafb',
    contrastLow: '#d1d6e0',
    contrastInvert: '#000000',
    surface: '#1f242e',
    surfaceAlt: '#14181e',
    background: '#090c0f',
    backgroundAlt: '#000000',
    secondary: '#3d475c',
    secondaryAlt: '#535f7a',
    error: '#ff5959',
    errorAlt: '#ff5959',
    warning: '#ffa359',
    warningAlt: '#ffa359',
    success: '#9affa6',
    successAlt: '#59ff67',
    code: {
        accent1: '#ff9ae1',
        accent2: '#9affa6',
        accent3: '#8ee8ff',
        accent4: '#c6d1db',
        accent5: '#c792ea',
        accent6: '#ffa359',
        accent7: '#9affe1',
        accent8: '#f2ff00',
        accent9: '#ff5959',
    },
    dataVis: {
        accent1: '#5188ff',
        accent2: '#7dedff',
        accent3: '#ff5469',
        accent4: '#a76fff',
        accent5: '#ff5bd4',
        accent6: '#ed2d22',
        accent7: '#ffC479',
        accent8: '#8aff6d',
        accent9: '#77869b',
        accent10: '#e0edff',
        accent11: '#ff7839',
        accent12: '#ff57C7',
    },
};
